import { render, staticRenderFns } from "./DataIteratorFilter.vue?vue&type=template&id=54080044&scoped=true"
import script from "./DataIteratorFilter.vue?vue&type=script&lang=js"
export * from "./DataIteratorFilter.vue?vue&type=script&lang=js"
import style0 from "./DataIteratorFilter.vue?vue&type=style&index=0&id=54080044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54080044",
  null
  
)

export default component.exports